import { render } from "./AppointmentConfigModal.vue?vue&type=template&id=470fc7ad&scoped=true"
import script from "./AppointmentConfigModal.vue?vue&type=script&lang=js"
export * from "./AppointmentConfigModal.vue?vue&type=script&lang=js"

import "./AppointmentConfigModal.vue?vue&type=style&index=0&id=470fc7ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470fc7ad"]])

export default __exports__